import styled from 'styled-components';

export const NavigationOverlay = styled.div`
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  
  width: 100%;
  height: 100%;
  
  background-color: rgba(0, 0, 0, 0.7);
`;

export const NavigationLogo = styled.div`
  position: absolute;
  top: 30px;
  left: 50px;
`;

export const NavigationContainer = styled.nav`
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  
  display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 30px;
  padding-top: 100px;
  
  background-color: ${({ theme }) => theme.blue};
  
  @media(min-width: 500px) {
    z-index: 3;
    
    width: 360px;
    padding: 0 50px;
    padding-top: 105px;
  }
  
  @media(min-width: 1024px) {
    position: static;
    
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    width: auto;
    height: auto;
    padding: 0;
    
    background-color: transparent;
  }
`;

export const NavigationList = styled.ul`
  @media(min-width: 1024px) {
    display: flex;
  }
`;

export const NavigationItem = styled.li`
  font-size: 14px;
  line-height: 1;
  
  a {
    color: inherit;
  }
  
  &:not(:last-child) {
    margin-bottom: 25px;
  }
  
  @media(min-width: 1024px) {
    font-weight: 400;
    font-size: 16px;
    
    &:not(:last-child) {
      margin-bottom: 0;
      margin-right: 40px;
    }
  }
`;
